import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "bootstrap-touchspin" }
const _hoisted_3 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexTouchspin',
  setup(__props) {

const DefaultTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/DefaultTouchspin.vue"))
const OutlinedTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/OutlinedTouchspin.vue"))
const IconsTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/IconsTouchspin.vue"))
const PostfixTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/PostfixTouchspin.vue"))
const RoundedTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/RoundedTouchspin.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Controls",
      mains: "Touchspin",
      title: "Touchspin"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(DefaultTouchspin)),
          _createVNode(_unref(OutlinedTouchspin)),
          _createVNode(_unref(IconsTouchspin)),
          _createVNode(_unref(PostfixTouchspin)),
          _createVNode(_unref(RoundedTouchspin))
        ])
      ])
    ])
  ], 64))
}
}

})